import { render, staticRenderFns } from "./TopUserGroupsInner.vue?vue&type=template&id=5f969bcc&scoped=true&"
import script from "./TopUserGroupsInner.vue?vue&type=script&lang=js&"
export * from "./TopUserGroupsInner.vue?vue&type=script&lang=js&"
import style0 from "./TopUserGroupsInner.vue?vue&type=style&index=0&id=5f969bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f969bcc",
  null
  
)

export default component.exports